export default __webpack_public_path__ + "5aeba526037ed5582b840a695d50ed18.svg";